import { UserRoleInput } from '../../inputs/user.input';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { UsersResponse, SubmitResponse , OneUserResponse } from '../../models';
import { UserInput, UserStatusInput } from '../../inputs/user.input';
import { HttpService } from './http.service';

@Injectable({
    providedIn: 'root',
  })
export class UserService extends HttpService<UserInput | UserStatusInput | UserRoleInput, UsersResponse > {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'user');
  }

  getAllUsers(page = 1): Observable<UsersResponse> {
    return this._getAllPaged('', page).pipe(catchError((error) => of(error)));
  }

  getUserById(id: string): Observable<OneUserResponse> {
    return this._getById(id).pipe(catchError((error) => of(error)));
  }

  createUser(user: UserInput): Observable<SubmitResponse> {
    return this.create(user, 'create').pipe(catchError((error) => of(error)));
  }

  updateUser(user: UserInput): Observable<SubmitResponse> {
    return this.update(user,'status').pipe(catchError((error) => of(error)));
  }

  updateUserStatus(user: UserStatusInput): Observable<SubmitResponse> {
    return this.update(user,'status').pipe(catchError((error) => of(error)));
  }

  updateUserRole(user: UserRoleInput): Observable<SubmitResponse> {
    return this.update(user,'role').pipe(catchError((error) => of(error)));
  }

  deleteUser(userId: string): Observable<SubmitResponse> {
    return this.delete(userId).pipe(catchError((error) => of(error)));
  }
}
